import { render, staticRenderFns } from "./PcRsNumContent.vue?vue&type=template&id=feea177e&"
import script from "./PcRsNumContent.vue?vue&type=script&lang=js&"
export * from "./PcRsNumContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports